import { format, isToday, isYesterday } from 'date-fns'

export function formatTime(timestamp) {
  const date = new Date(timestamp)
  return format(date, 'h:mm:ss a')
}

export function formatDayDivider(timestamp) {
  const date = new Date(timestamp)
  if (isToday(date)) return 'Today'
  if (isYesterday(date)) return 'Yesterday'
  return format(date, 'EEEE, MMMM do')
}

export function formatShortTime(timestamp) {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  if (isNaN(date.getTime())) return ''
  if (isToday(date)) return format(date, 'h:mm a')
  if (isYesterday(date)) return 'Yesterday'
  const now = new Date()
  const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24))
  if (diffDays < 7) return format(date, 'EEE')
  return format(date, 'MMM d')
}
